import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M16.375 1.874a2 2 0 0 1 2 2v3h1.75a2 2 0 0 1 1.995 1.85l.005.15v6.25a2 2 0 0 1-2 2h-1.75v4.25a.75.75 0 0 1-.75.75H6.375a.75.75 0 0 1-.75-.75v-4.25h-1.75a2 2 0 0 1-1.995-1.85l-.005-.15v-6.25a2 2 0 0 1 2-2h1.75v-3a2 2 0 0 1 2-2h8.75zm.5 11.5h-9.75v7.25h9.75v-7.25zm-3.625 3.5a.75.75 0 1 1 0 1.5H8.875a.75.75 0 0 1 0-1.5zm1.875-2.5a.75.75 0 1 1 0 1.5h-6.25a.75.75 0 0 1 0-1.5zm5-6H3.875a.5.5 0 0 0-.5.5v6.25a.5.5 0 0 0 .5.5h1.75v-3a.75.75 0 0 1 .75-.75h11.25a.75.75 0 0 1 .75.75v3h1.75a.5.5 0 0 0 .492-.41l.008-.09v-6.25a.5.5 0 0 0-.5-.5zm-13.75 1a.75.75 0 0 1 0 1.5h-1.25a.75.75 0 0 1 0-1.5zm10-6h-8.75a.5.5 0 0 0-.5.5v3h9.75v-3a.5.5 0 0 0-.5-.5z' />
  </svg>
);
